import {
  Str_AddFriends,
  Str_CreateGroupChat,
} from "../../../language/string_res";
import AddFriendIcon from "../../../assets/svg/icon_add_friend.svg";
import CreateGroupIcon from "../../../assets/svg/icon_create_group.svg";
import AddIcon from "../../../assets/svg/icon_add.svg";
import { useRef, useState } from "react";
import { Modal, Pressable, Text, TouchableOpacity, View } from "react-native";
import { white } from "../../../assets/style/colors";
import { useAppNavigation } from "../../navigation";

export const AddMenu = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigation = useAppNavigation();
  const PopupData = [
    { name: Str_AddFriends, icon: <AddFriendIcon /> },
    { name: Str_CreateGroupChat, icon: <CreateGroupIcon /> },
  ];

  const viewRef = useRef<View>(null);

  // 使用ref和state来存储按钮位置
  const [buttonPosition, setButtonPosition] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  // 处理按钮的onLayout事件，获取按钮位置
  const handleButtonLayout = (event: any) => {
    viewRef.current?.measureInWindow((x, y, width, height) => {
      // 对于三栏布局，我们需要调整弹窗的位置
      let finalX = x + width - 150;
      setButtonPosition({ x: finalX, y, width, height });
    });
  };

  function onPress() {
    setIsVisible(!isVisible);
  }
  const handPopupClick = (index: number) => {
    setIsVisible(false)
    if (index == 0) {
      // 打开搜索好友模态框
      navigation.navigate("SearchFriend");
    } else if (index == 1) {
      // 打开创建群聊模态框
      navigation.navigate("ForwardNewChat", { from: "Create" });
    } 
  };
  return (
    <View
      ref={viewRef}
      style={{ position: "relative", zIndex: 1 }}
      onLayout={handleButtonLayout}
    >
      {/* 加号按钮 */}
      <Pressable
        onPress={onPress}
        style={{
          backgroundColor: "#F0F0F0",
          width: 45,
          height: 45,
          borderRadius: 8,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <AddIcon width={24} height={24} />
      </Pressable>

      {/* 弹出菜单内容 */}
      <Modal
        visible={isVisible}
        animationType="fade"
        transparent={true}
        statusBarTranslucent={true}
        onRequestClose={() => setIsVisible(false)}
      >
        {/* 遮罩层 */}
        <Pressable style={{ flex: 1 }} onPress={() => setIsVisible(false)}>
          {/* 弹窗内容 */}
          <Pressable
            style={{
              position: "absolute",
              top: buttonPosition.y + buttonPosition.height + 8,
              left: buttonPosition.x,
              backgroundColor: "#333333",
              borderRadius: 8,
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.3,
              shadowRadius: 4,
              elevation: 9999,
              width: 150,
              zIndex: 9999,
            }}
            onPress={(e) => e.stopPropagation()}
          >
            {PopupData.map((item, index) => {
              return (
                <TouchableOpacity
                  key={item.name}
                  style={{
                    flexDirection: "row",
                    paddingHorizontal: 16,
                    paddingVertical: 12,
                    alignItems: "center",
                  }}
                  onPress={() => {
                    setIsVisible(false);
                    handPopupClick(index);
                  }}
                >
                  {item.icon}
                  <Text
                    style={{
                      color: white,
                      fontSize: 16,
                      marginStart: 12,
                      width: "auto",
                    }}
                  >
                    {item.name}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </Pressable>
        </Pressable>
      </Modal>
    </View>
  );
};
